import React from 'react';

import i18n from '@yandex-int/i18n';
import { wrapInText } from 'client/lib/i18n-utils';
import * as keyset from 'i18n/Settings';

import Description from '../Form/Description/Description';
import { PictureHint } from '../Hint/PictureHint';

const t = i18n(keyset);

const idHintUrl = `${__appConfig.app.staticResourcesUrl}/dialogs/dev-console/images/smart-home-device-id-hint.png`;
const badgeHintUrl = `${__appConfig.app.staticResourcesUrl}/dialogs/dev-console/images/smart-home-alice-badge-hint.png`;

export const DeviceLinkingDescription: React.FC = () => {
    return (
        <Description>
            {wrapInText(
                (_) => <PictureHint src={idHintUrl} directions={['bottom-left']} />,
                (_) => <PictureHint src={badgeHintUrl} directions={['bottom-left']} />,
            )(t('devices-add-market'))}
        </Description>
    );
};
